import React, { useEffect, useState, useRef } from "react";
import { Col, Input, Row, Table, Tooltip } from "antd";
import HeadingBack from "../component/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SvgIcon from "../const/SvgIcon";
import { allapiAction } from "../../Redux/common/action";
import moment from "moment";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Modal, Space } from "antd";
import { URL } from "../../Redux/common/url";
import ReactToPrint from "react-to-print";

function GpgMq() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pagev = searchParams.get("page");
  const searchData = searchParams.get("search");
  const deteMonths = searchParams.get("deteMonths");
  const componentRef = useRef();
  const { confirm } = Modal;

  const page = pagev == null ? 1 : pagev;
  const search = searchData == null ? "" : searchData;
  const deteMonth = deteMonths == null ? "" : deteMonths;

  console.log(searchParams);
  console.log(page);
  console.log(searchData);

  const order_list = useSelector((state) =>
    state?.allapi?.order_list ? state?.allapi?.order_list : {}
  );
  const order_details = useSelector((state) =>
    state?.allapi?.order_details ? state?.allapi?.order_details : {}
  );
  const get_invoice_details = useSelector((state) =>
    state?.allapi?.get_invoice_details ? state?.allapi?.get_invoice_details : {}
  );

  const [pages, setPage] = useState(1);

  const listdata = order_list?.docs ? order_list?.docs : [];
  function getCurrentMonthYear() {
    const currentDate = new Date();
    const month = currentDate.toLocaleString("default", { month: "short" });
    const year = currentDate.getFullYear();
    return `${month} ${year}`;
  }
  useEffect(() => {
    if (deteMonth) {
      //   dispatch(allapiAction.getSearchOrderAdmin({ page: page, key: search }));
      dispatch(
        allapiAction.getctGpg({ page: page, monthyears: deteMonth, status: 4 })
      );
    } else {
      const currentMonthYear = getCurrentMonthYear();
      dispatch(
        allapiAction.getctGpg({
          page: page,
          monthyears: currentMonthYear,
          status: 4,
        })
      );
    }
    // dispatch(allapiAction.getInvoceDetails());
    return () => {};
  }, [location]);

  const hendletoMonthReports = (e) => {
    console.log(e);
    navigate("/gpg-mq?page=" + 1 + "&deteMonths=" + e);
    // userMonthIncome

    // dispatch(allapiAction.userMonthIncome({ monthyears: e }));
  };

  const hendlePahegi = (e) => {
    setPage(e);

    console.log(location);

    if (deteMonth) {
      navigate("/gpg-mq?page=" + e + "&deteMonths=" + deteMonth);
    } else {
      const currentMonthYear = getCurrentMonthYear();
      navigate("/gpg-mq?page=" + e + "&deteMonths=" + currentMonthYear);
    }

    // if (search) {
    //   dispatch(allapiAction.getuserListSearch({ page: e, search: search }));
    //   return () => {};
    // } else {
    //   dispatch(allapiAction.getuserList(e));

    //   return () => {};
    // }
  };

  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        hendleDelete(e);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const hendleDelete = (e) => {
    console.log(e);
    // deleteProduct
    // setShowDelete(false);
    dispatch(allapiAction.deleteProduct({ productId: e, pageNo: page }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };
  const dataSource = [
    {
      key: "1",
      name: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userId, setuserId] = useState("");

  const [statusData, setstatusData] = useState({});
  const [userData, setuserData] = useState({});
  const [statusDataBox, setstatusDataBox] = useState(false);
  const [statusDataBoxView, setstatusDataBoxView] = useState(false);
  const [statusDataBoxReturn, setstatusDataBoxReturn] = useState(false);
  const [productID, setproductID] = useState("");
  const [statusUpTrStatus, setstatusUpTrStatus] = useState("");
  const [statusUpTrId, setstatusUpTrId] = useState("");
  const hendleToViewM = (e) => {
    setstatusDataBox(true);
    setuserData(e);
    setproductID(e);
    dispatch(allapiAction.getuserOrderDetails({ _id: e?._id }));
  };
  const hendleToViewProduct = (e) => {
    setstatusDataBoxView(true);
    setuserData(e);
    setproductID(e);
    dispatch(allapiAction.getuserOrderDetails({ _id: e?._id }));
  };
  const hendleToViewReturn = (e) => {
    setstatusDataBoxReturn(true);
    // setuserData(e);
    setstatusUpTrId(e);
    // dispatch(allapiAction.getuserOrderDetails({ _id: e?._id }));
  };
  const hendleSubmitReturn = (e) => {
    setstatusDataBoxReturn(false);
    dispatch(
      allapiAction.cancelOrderByAdmin({
        _id: statusUpTrId?._id,
        user_id: statusUpTrId?.user_id?._id,
        description: statusUpTrStatus,
        page: page,
      })
    );
    setstatusUpTrStatus("");
    // dispatch(allapiAction.getuserOrderDetails({ _id: e?._id }));
  };

  const shippingCharge = order_details?.sub_total > 10000 ? 699 : 199;
  console.log(order_details?.orderproductsList);

  const totalSubtotalPricegstdd = order_details?.orderproductsList?.reduce(
    (total, obj) => {
      return total + (obj.sub_total * obj?.gst) / 100;
    },
    0
  );
  // return total +(obj.subtotalprice * obj?.gst) / 100 ;
  // console.log(shippingCharge)
  // console.log(totalSubtotalPricegstdd)

  const totalSubtotalPricegst = totalSubtotalPricegstdd;

  const totalAmount =
    order_details?.sub_total + shippingCharge + totalSubtotalPricegstdd;
  const hendleTochangedata = (e) => {
    const { name, value } = e.target;

    setstatusData({ ...statusData, [name]: value });
  };

  const hendleToSubmetUpdate = () => {
    dispatch(
      allapiAction.addFoundByAdmin({
        id: userData?._id,
        amount: statusData?.amount,

        pageNumber: page,
      })
    );

    setstatusDataBox(false);
  };

  const showModal = (e) => {
    console.log(e);
    setuserId(e);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    dispatch(
      allapiAction.user_inactive({
        _id: userId,
        status: userId,
        // active: 0,
        pageNumber: page,
      })
    );
    setuserId("");
    setIsModalOpen(false);
    return () => {};
  };

  const hendleToChangeStatus = (id, status) => {
    dispatch(
      allapiAction.user_inactive({
        _id: id,
        status: status,
        // active: 0,
        pageNumber: page,
      })
    );
    // setuserId("");
    // setIsModalOpen(false);
    return () => {};
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const hendleToStatus = (id, e) => {
    // statusCategory

    dispatch(allapiAction.statusProduct({ productId: id, status: e }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
    // {
    //   title: "Sell Code",
    //   dataIndex: "sellCode",
    //   key: "sellCode",
    //   className: "table_action_col",
    // },

    {
      title: "User Code",
      dataIndex: "referId",
      key: "referId",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer coustomNevc"
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.userId?.referId}
            </span>
          </>
        );
      },
    },
    {
      title: "User Name",
      dataIndex: "referId",
      key: "referId",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer coustomNevc"
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.userId?.fullName}
            </span>
          </>
        );
      },
    },

    // {
    //   title: "Sponsor Code",
    //   dataIndex: "referByuserId",
    //   key: "referByuserId",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         {/* <Tooltip title="Contact"> */}
    //         <span
    //           className="cursor-pointer coustomNevc"
    //           // onClick={() => navigate(`/user-details/${item?.referId}`)}
    //         >
    //           {item?.userId?.referBy}

    //           {/* <p> {item?.user_id?.referByuserId?.referId}</p> */}
    //         </span>
    //       </>
    //     );
    //   },
    // },

    {
      title: "Number",
      dataIndex: "phone",
      key: "phone",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer "
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.userId?.phone}
            </span>
          </>
        );
      },
    },
    // {
    //   title: "Name",
    //   dataIndex: "title",
    //   key: "title",
    // },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <Tooltip title={item?.status}>
    //           <button
    //             className={
    //               item?.status == "Active"
    //                 ? "success-button ml-3"
    //                 : "delete-button ml-3"
    //             }
    //             onClick={() =>
    //               hendleToStatus(
    //                 item?._id,
    //                 item?.status == "Active" ? "Inactive" : "Active"
    //               )
    //             }
    //           >
    //             {item?.status}
    //           </button>
    //         </Tooltip>
    //       </>
    //     );
    //   },
    // },
    // {
    //   title: "Upline Id",
    //   dataIndex: "referBy",
    //   key: "referBy",
    // },
    // {
    //   title: "Number",
    //   dataIndex: "phone",
    //   key: "phone",
    // },
    // {
    //   title: "Password",
    //   dataIndex: "passwordPlan",
    //   key: "passwordPlan",
    // },
    // {
    //   title: "Wallet",
    //   dataIndex: "balance",
    //   key: "balance",
    // },
    // {
    //   title: "Wallet",
    //   dataIndex: "Wallet",
    //   key: "Wallet",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>

    //         <span
    //           className="cursor-pointer"
    //           // onClick={() => navigate(`/users/contact/${item?.id}`)}
    //         >
    //           {item?.walletId?.closeBal}
    //         </span>
    //       </>
    //     );
    //   },
    // },
    // {
    //   title: "Reffer Code",
    //   dataIndex: "referCode",
    //   key: "referCode",
    // },
    {
      title: "Amount",
      dataIndex: "grand_total",
      key: "grand_total",
      className: "table_first_col",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer"
              // onClick={() => navigate(`/users/contact/${item?.id}`)}
            >
              {moment(item?.createdAt).format(" DD/MM/YYYY ")}
            </span>
          </>
        );
      },
    },
    //     {
    //       title: "Status",
    //       dataIndex: "status",
    //       key: "status",
    //       className: "table_action_col",
    //       render: (value, item, index) => {

    //         const userRank =
    //         item?.status == '0'
    //           ? 'free'
    //           : item?.status == '1'
    //           ? 'FRANCHISE'
    //           : item?.status == '2'
    //           ? 'BARON'
    //           : item?.status == '3'
    //           ? 'COUNT'
    //           : item?.status == '4'
    //           ? 'MARQUISE'
    //           : item?.status == '4'
    //           ? 'DUKE'
    //           : 'ARCH DUKE'
    //         return (
    //           <>

    // <span
    //               className="cursor-pointer"

    //             >
    //              {userRank}
    //             </span>

    //           </>
    //         );
    //       },
    //     },
  ];

  const [searchs, setsearch] = useState("");
  const handleChange = (e) => {
    setsearch(e);
    setPage(1);
    navigate("/sale?page=" + 1 + "&search=" + e);
    // if (e) {
    //   dispatch(allapiAction.getuserListSearch({ page: 1, search: e }));
    //   return () => {};
    // } else {
    //   dispatch(allapiAction.getuserList(1));

    //   return () => {};
    // }
    // getuserListSearch
    // &user_id=${data?.user_id}&search=${data?.user_id}
  };

  const [monthList, setmonthList] = useState([]);

  function getMonthList() {
    const startDate = new Date("2021-08-01");
    const currentDate = new Date();

    // Calculate the month one less than the current month
    currentDate.setMonth(currentDate.getMonth() - 1);

    const monthsList = [];

    while (startDate <= currentDate) {
      monthsList.push(
        startDate.toLocaleString("default", { month: "short", year: "numeric" })
      );

      startDate.setMonth(startDate.getMonth() + 1);
    }

    return monthsList;
  }

  useEffect(() => {
    const months = getMonthList();
    setmonthList(months);
    // console.log(months);
  }, []);

  return (
    <div>
      <Modal
        title="delete User"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>Are you sure delete</p>
      </Modal>

      <Modal
        title="Inovice"
        centered
        open={statusDataBox}
        // onOk={() => hendleToSubmetUpdate(false)}
        onCancel={() => setstatusDataBox(false)}
        width={800}
      >
        <div
          id="kt_app_content"
          className="app-content flex-column-fluid"
          ref={componentRef}
        >
          {/* -begin::Content container-*/}
          <div
            id="kt_app_content_container"
            className="app-container container-xxl"
          >
            {/* - begin::Invoice 3-*/}
            <div className="">
              {/* - begin::Body-*/}
              <div className="card-body py-20">
                {/* - begin::Wrapper-*/}
                <div className="mw-lg-950px mx-auto w-100">
                  {/* - begin::Header-*/}

                  <div className="d-flex justify-content-between flex-column flex-sm-row mb-19">
                    <div>
                      <h4 className="fw-bolder text-gray-800 fs-2qx pe-5 pb-7">
                        INVOICE
                      </h4>
                      {/* -end::Logo-*/}
                      <div className="fw-bold fs-2">
                        Dear, {order_details?.address_id?.name}
                        {/* <span className='fs-6'>(f.mit@kpmg.com)</span>, */}
                        <br />
                        <span className="text-muted fs-5">
                          Email : {order_details?.address_id?.email}
                        </span>
                        <br />
                        <span className="text-muted fs-5">
                          Number : {order_details?.address_id?.phone}
                        </span>
                        <br />
                        <span className="text-muted fs-5">
                          Address : {order_details?.address_id?.address}
                        </span>
                        <br />
                        <span className="text-muted fs-5">
                          City : {order_details?.address_id?.city}
                        </span>
                        <br />
                        <span className="text-muted fs-5">
                          State : {order_details?.address_id?.state}
                        </span>
                        <br />
                        <span className="text-muted fs-5">
                          Pincode : {order_details?.address_id?.pincode}
                        </span>
                        <span className="text-muted fs-5">
                          {/* Here are your order details. We thank you for your purchase. */}
                          {/* sd */}
                        </span>
                      </div>
                    </div>

                    <div className="text-sm-end">
                      {/* -begin::Logo-*/}
                      <a
                        href="#"
                        style={{ width: "150px" }}
                        className="d-block mw-150px ms-sm-auto"
                      >
                        <img
                          alt="Logo"
                          src={
                            URL.API_BASE_URL + get_invoice_details?.invoiceLogo
                          }
                          className="w-100"
                        />
                      </a>
                      {/* -end::Logo-*/}
                      {/* -begin::Text-*/}
                      <div className="text-sm-end fw-semibold fs-4 text-muted mt-7">
                        <div>{get_invoice_details?.companyName}</div>
                        <div>{get_invoice_details?.email}</div>
                        <div>{get_invoice_details?.address}</div>
                        {/* <div>Mississippi 96522</div> */}
                      </div>
                      {/* -end::Text-*/}
                    </div>
                  </div>
                  {/* -end::Header-*/}
                  {/* -begin::Body-*/}
                  <div className="pb-12">
                    {/* -begin::Wrapper-*/}
                    <div className="d-flex flex-column gap-7 gap-md-10">
                      {/* -begin::Message-*/}
                      <div className="fw-bold fs-2">
                        Dear, {order_details?.address_id?.name}
                        {/* <span className='fs-6'>(f.mit@kpmg.com)</span>, */}
                        <br />
                        <span className="text-muted fs-5">
                          {/* Here are your order details. We thank you for your purchase. */}
                        </span>
                      </div>
                      {/* -begin::Message-*/}
                      {/* -begin::Separator-*/}
                      <div className="separator"></div>
                      {/* -begin::Separator-*/}
                      {/* -begin::Order details-*/}
                      <div className="d-flex flex-column flex-sm-row gap-7 gap-md-10 fw-bold">
                        <div className="flex-root d-flex col-6 flex-column">
                          <span className="text-muted">Order ID</span>
                          <span className="fs-5">#{productID?._id}</span>
                          <span className="text-muted">Transation ID</span>
                          <span className="fs-5">
                            #{productID?.transationId}
                          </span>
                          <span className="text-muted">Paid Status</span>
                          <span className="fs-5">{productID?.paidstatus}</span>
                        </div>
                        <div className="flex-root d-flex col-6 flex-column">
                          <span className="text-muted">Date</span>
                          <span className="fs-5">
                            {moment(productID?.createdAt).format(
                              " MMMM Do YYYY"
                            )}
                          </span>
                        </div>
                        {/* <div className='flex-root d-flex flex-column'>
                                  <span className='text-muted'>Invoice ID</span>
                                  <span className='fs-5'>#INV-000414</span>
                                </div>
                                <div className='flex-root d-flex flex-column'>
                                  <span className='text-muted'>Shipment ID</span>
                                  <span className='fs-5'>#SHP-0025410</span>
                                </div> */}
                      </div>
                      {/* -end::Order details-*/}
                      {/* -begin::Billing & shipping-*/}
                      {/* <div className='d-flex flex-column flex-sm-row gap-7 gap-md-10 fw-bold'>
                                <div className='flex-root d-flex flex-column'>
                                  <span className='text-muted'>Billing Address</span>
                                  <span className='fs-6'>
                                    Unit 1/23 Hastings Road,
                                    <br />
                                    Melbourne 3000,
                                    <br />
                                    Victoria,
                                    <br />
                                    Australia.
                                  </span>
                                </div>
                                <div className='flex-root d-flex flex-column'>
                                  <span className='text-muted'>Shipping Address</span>
                                  <span className='fs-6'>
                                    Unit 1/23 Hastings Road,
                                    <br />
                                    Melbourne 3000,
                                    <br />
                                    Victoria,
                                    <br />
                                    Australia.
                                  </span>
                                </div>
                              </div> */}
                      {/* -end::Billing & shipping-*/}
                      {/* -begin:Order summary-*/}
                      <div className="d-flex justify-content-between flex-column">
                        {/* -begin::Table-*/}
                        <div className="table-responsive border-bottom mb-9">
                          <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                            <thead>
                              <tr className="border-bottom fs-6 fw-bold text-muted">
                                <th className="min-w-175px pb-2">Item</th>
                                <th className="min-w-70px text-end pb-2">
                                  Color
                                </th>
                                <th className="min-w-70px text-end pb-2">
                                  Size
                                </th>
                                <th className="min-w-70px text-end pb-2">
                                  Unit Cost
                                </th>
                                <th className="min-w-80px text-end pb-2">
                                  Quantity
                                </th>
                                <th className="min-w-100px text-end pb-2">
                                  Amount
                                </th>
                              </tr>
                            </thead>
                            <tbody className="fw-semibold text-gray-600">
                              {/* -begin::Products-*/}

                              {order_details?.orderproductsList &&
                                order_details?.orderproductsList?.map(
                                  (data, i) => {
                                    console.log(data);

                                    return (
                                      <tr>
                                        {/* -begin::Product-*/}
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <div className="ms-5">
                                              <div className="fw-bold">
                                                {data?.product_names}
                                              </div>
                                              <div className="fs-7 text-muted">
                                                {/* Delivery Date: 23/11/2022 */}
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                        {/* -end::Product-*/}
                                        {/* -begin::SKU-*/}
                                        <td className="text-end">
                                          {" "}
                                          {data?.colorId?.color}
                                        </td>
                                        <td className="text-end">
                                          {" "}
                                          {data?.sizeId?.size}
                                        </td>
                                        <td className="text-end">
                                          {" "}
                                          {data?.product_price}
                                        </td>
                                        {/* -end::SKU-*/}
                                        {/* -begin::Quantity-*/}
                                        <td className="text-end">
                                          {" "}
                                          {data?.itme_count}
                                        </td>
                                        {/* -end::Quantity-*/}
                                        {/* -begin::Total-*/}
                                        <td className="text-end">
                                          ₹ {data?.sub_total}
                                        </td>
                                        {/* -end::Total-*/}
                                      </tr>
                                    );
                                  }
                                )}

                              {/* -end::Products-*/}
                              {/* -begin::Subtotal-*/}
                              <tr>
                                <td colSpan={5} className="text-end">
                                  Subtotal
                                </td>
                                <td className="text-end">
                                  ₹ {order_details?.sub_total}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan={5} className="text-end">
                                  Shipping
                                </td>
                                <td className="text-end">₹ {shippingCharge}</td>
                              </tr>
                              <tr>
                                <td colSpan={5} className="text-end">
                                  Gst
                                </td>
                                <td className="text-end">
                                  ₹ {totalSubtotalPricegst}
                                </td>
                              </tr>

                              <tr>
                                <td
                                  colSpan={5}
                                  className="fs-3 text-dark fw-bold text-end"
                                >
                                  Grand Total
                                </td>
                                <td className="text-dark fs-3 fw-bolder text-end">
                                  ₹ {totalAmount}
                                </td>
                              </tr>
                              {/* -end::Grand total-*/}
                            </tbody>
                          </table>
                        </div>
                        {/* -end::Table-*/}
                      </div>
                      {/* -end:Order summary-*/}
                    </div>
                    {/* -end::Wrapper-*/}
                  </div>
                  {/* -end::Body-*/}
                  {/* - begin::Footer-*/}
                  {/* <div className='d-flex flex-stack flex-wrap mt-lg-20 pt-13'>
                            
                            <div className='my-1 me-5'>
                           
                              <button
                                type='button'
                                className='btn btn-success my-1 me-12'
                                // onclick='window.print();'
                              >
                                Print Invoice
                              </button>
                          
                              <button type='button' className='btn btn-light-success my-1'>
                                Download
                              </button>
                            
                            </div>
                           
                            <a
                              href='../../demo1/dist/apps/invoices/create.html'
                              className='btn btn-primary my-1'
                            >
                              Create Invoice
                            </a>
                           
                          </div> */}
                  {/* - end::Footer-*/}
                </div>
                {/* - end::Wrapper-*/}
              </div>
              {/* - end::Body-*/}
            </div>
            {/* - end::Invoice 1-*/}
          </div>
          {/* -end::Content container-*/}
        </div>
        <div className="row">
          <div className="col-6"></div>
          <div className="col-6">
            <ReactToPrint
              trigger={() => (
                <Button variant="primary" onClick={hendleDelete}>
                  Print / Download
                </Button>
                // <button className='bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded shadow border-2 border-blue-500 hover:bg-transparent hover:text-blue-500 transition-all duration-300'>
                //   Print / Download
                // </button>
              )}
              content={() => componentRef.current}
            />
          </div>
        </div>
      </Modal>
      <Modal
        title="Order Details"
        centered
        open={statusDataBoxView}
        onOk={() => setstatusDataBoxView(false)}
        onCancel={() => setstatusDataBoxView(false)}
        width={1200}
      >
        <div className="">
          <div>
            {/* <h6>Name</h6>
                    <p>{roleID?.name}</p> */}
            {/* <div className='productDetailsImg'>
                      <img src={URL.API_BASE_URL + roleID?.featureImage} alt='' />
                    </div> */}
            <div className="row">
              <div className="col-4">
                <h6> id : -</h6>
              </div>
              <div className="col-8">
                <p>{order_details?._id}</p>
              </div>

              <div className="col-4">
                <h6>payment mode name : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.payment_mode_name}</p>
              </div>

              <div className="col-4">
                <h6>sub total : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.sub_total}</p>
              </div>
            </div>
            <hr />
            <h3>user Details</h3>
            <div className="row">
              <div className="col-4">
                <h6> user id : -</h6>
              </div>
              <div className="col-8">
                <p>{order_details?.user_id?._id}</p>
              </div>

              <div className="col-4">
                <h6>user reffer id : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.user_id?.referId}</p>
              </div>

              <div className="col-4">
                <h6>full name : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.user_id?.fullName}</p>
              </div>
              <div className="col-4">
                <h6>Email : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.user_id?.email}</p>
              </div>
            </div>
            <hr />
            <h3>shipping address</h3>
            <div className="row">
              <div className="col-4">
                <h6> name : -</h6>
              </div>
              <div className="col-8">
                <p>{order_details?.address_id?.name}</p>
              </div>

              <div className="col-4">
                <h6>email : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.address_id?.email}</p>
              </div>

              <div className="col-4">
                <h6>phone : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.address_id?.phone}</p>
              </div>
              <div className="col-4">
                <h6>address : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.address_id?.address}</p>
              </div>
              <div className="col-4">
                <h6>city : -</h6>
              </div>
              <div className="col-8">
                <p>{order_details?.address_id?.city}</p>
              </div>
              <div className="col-4">
                <h6>state : -</h6>
              </div>
              <div className="col-8">
                <p>{order_details?.address_id?.state}</p>
              </div>
              <div className="col-4">
                <h6>pincode : -</h6>
              </div>

              <div className="col-8">
                <p>{order_details?.address_id?.pincode}</p>
              </div>
            </div>

            <hr />
            <h3>Order Product</h3>
            {order_details?.orderproductsList &&
              order_details?.orderproductsList?.map((data, i) => {
                return (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <h3>sub order id</h3>
                      </div>
                      <div className="col-6">
                        <p>{data?.sub_order_id}</p>
                      </div>
                      <div className="col-6">
                        <h3>name</h3>
                      </div>
                      <div className="col-6">
                        <p>{data?.product_names}</p>
                      </div>
                      <div className="col-6">
                        <h3>Color</h3>
                      </div>
                      <div className="col-6">
                        <p>{data?.colorId?.color}</p>
                      </div>
                      <div className="col-6">
                        <h3>size</h3>
                      </div>
                      <div className="col-6">
                        <p>{data?.sizeId?.size}</p>
                      </div>

                      <div className="col-6">
                        <h3>product price</h3>
                      </div>
                      <div className="col-6">
                        <p>{data?.product_price}</p>
                      </div>
                      <div className="col-6">
                        <h3>item Count</h3>
                      </div>
                      <div className="col-6">
                        <p>{data?.itme_count}</p>
                      </div>
                      <div className="col-6">
                        <h3>sub total</h3>
                      </div>
                      <div className="col-6">
                        <p>{data?.sub_total}</p>
                      </div>
                      <div className="col-6">
                        <h3>feture image</h3>
                      </div>
                      <div className="col-6">
                        <div style={{ width: "100px" }}>
                          <img
                            src={URL.API_BASE_URL + data?.colorId?.featureImage}
                            alt=""
                            style={{ width: "100%" }}
                          />
                        </div>
                        {/* <p>  {data?.sub_total}</p> */}
                      </div>
                    </div>

                    <hr />
                  </div>
                );
              })}

            {/* <h6>product Image</h6> */}
            {/* <div className='row'>
                      {roleID?.images &&
                        roleID?.images?.map((data: any, i: any) => {
                          console.log(data)

                          return (
                            <div className='col-3 proMultiImg'>
                              <img src={URL.API_BASE_URL + data?.img} alt='' />
                            </div>
                          )
                        })}
                    </div> */}
          </div>
        </div>
      </Modal>
      <Modal
        title="Return order"
        centered
        open={statusDataBoxReturn}
        onOk={() => hendleSubmitReturn(false)}
        onCancel={() => setstatusDataBoxReturn(false)}
        width={500}
      >
        <div>
          <Row>
            <Col span={24}>Description</Col>
            <Col span={24}>
              <Input
                name="description"
                placeholder="enter description..."
                value={statusUpTrStatus}
                onChange={(e) => {
                  setstatusUpTrStatus(e?.target?.value);
                }}
              />
            </Col>
          </Row>
        </div>
      </Modal>

      <div className="flex">
        <div>
          <HeadingBack
            title={"Gpg Mq"}
            subHeading={`Total ${order_list?.totalDocs || 0} Gpg Mq`}
          />
        </div>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          <select
            onChange={(e) => {
              hendletoMonthReports(e.target?.value);
            }}
            className="form-select"
          >
            <option value={""} selected>
              Select Month
            </option>

            {monthList &&
              monthList?.map((data, i) => {
                return (
                  <option value={data} key={i}>
                    {data}
                  </option>
                );
              })}
          </select>
          {/* <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Search..."
            // value={values?.TestCode}
          /> */}
          {/* <AsyncPaginate
            // key={managerKey}
            value={seleceteManger}
            loadOptions={loadOptionsgetManager}
            onChange={setseleceteManger}
            additional={{
              page: 1,
            }}
          /> */}
        </Col>

        {/* <div className="flex1 flex justify-content-end align-items-center">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => navigate("/user/add")}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div> */}
      </div>

      <div className="tableResponsive mt-10">
        <Table
          className={"table antd_table"}
          dataSource={listdata}
          columns={columns}
          pagination={{
            current: parseInt(page),
            pageSize: 10,
            onChange(current, pageSize) {
              hendlePahegi(current);
            },
            hideOnSinglePage: true,
            total: order_list?.totalDocs ? order_list?.totalDocs : 0,
          }}
        />
      </div>
    </div>
  );
}

export default GpgMq;
